export type WeatherKind = 'clear' | 'partly-cloudy' | 'cloudy' | 'rain' | 'snow';

export interface WeatherInfo {
  kind: WeatherKind;
  label: string;
}

export const WEATHER_LABELS: Record<WeatherKind, string> = {
  clear: '맑음',
  'partly-cloudy': '구름 조금',
  cloudy: '흐림',
  rain: '비',
  snow: '눈'
};

/** 데모용 주간 예보 (API 연동 전) */
export const DEMO_FORECAST_KINDS: WeatherKind[] = ['cloudy', 'cloudy', 'clear', 'clear', 'rain'];

export const DEMO_CURRENT_WEATHER: WeatherInfo = {
  kind: 'clear',
  label: WEATHER_LABELS.clear
};

export function weatherInfoFromKind(kind: WeatherKind): WeatherInfo {
  return { kind, label: WEATHER_LABELS[kind] };
}
